import Proptypes from 'prop-types'
import { isPartVisible } from 'utils/displayByDateAndTime'
import Text from 'components/Text'
import Subtitle from 'components/Subtitle'
import Separator from 'components/Separator'
import Framed from 'components/Framed'

export const PartText = ({ part, themeInfos }) => {
  if (!isPartVisible(part)) return null

  switch (part.type) {
    case 'H2':
      return <Subtitle text={part.text} subtiltleSize={part.subtitleSize} />
    case 'Text':
      return <Text text={part.text} />
    case 'Separator':
      return <Separator length={part.length} themeInfos={themeInfos} />
    case 'Framed':
      return <Framed text={part.text} style={part.style} themeInfos={themeInfos} />
    default:
      return null
  }
}

PartText.propTypes = {
  part: Proptypes.object,
  themeInfos: Proptypes.object,
}

export default PartText
